import React from 'react';
import { ArrowUp } from 'lucide-react';

const Footer = ({ isDarkMode }) => {
  const quote = "The narrower the truth, the wider the wisdom.";
  const established = "Established 2015 • I.DIA Wisdom Archive";

  // The Zen Hammer for perfect Pills
  const pillStyle = { borderRadius: '9999px' };

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    });
  };

  return (
    <footer className={`relative z-10 py-32 px-6 border-t bg-transparent transition-colors duration-700 ${isDarkMode ? 'border-stone-900/50' : 'border-stone-100'}`}>
      <div className="max-w-2xl mx-auto text-center space-y-20">
        
        {/* Scholarly Quote Section - Increased spacing for breathability */}
        <div className="space-y-8 animate-in fade-in duration-1000">
           <div className={`w-8 h-px mx-auto ${isDarkMode ? 'bg-stone-800' : 'bg-stone-200'}`} />
           <p className={`text-2xl md:text-3xl font-serif italic leading-relaxed opacity-80 ${isDarkMode ? 'text-stone-100' : 'text-stone-900'}`}>
             "{quote}"
           </p>
           <div className={`w-8 h-px mx-auto ${isDarkMode ? 'bg-stone-800' : 'bg-stone-200'}`} />
        </div>
        
        {/* Functional Ascend Button - Guaranteed Pill Shape */}
        <div className="flex justify-center">
          <button 
            onClick={scrollToTop}
            style={pillStyle}
            className="group flex items-center space-x-3 px-8 py-3 border border-stone-200 dark:border-stone-800 text-[10px] font-bold uppercase tracking-[0.2em] transition-all duration-500 hover:bg-stone-900 hover:text-white dark:hover:bg-white dark:hover:text-stone-900 text-stone-500 dark:text-stone-400"
          >
            <ArrowUp size={14} className="group-hover:-translate-y-1 transition-transform duration-500" />
            <span>Ascend</span>
          </button>
        </div>

        {/* Brand Signature */}
        <div className="space-y-6 pt-12">
          <div 
            className="text-2xl font-serif font-bold tracking-tight select-none"
            style={{ fontFamily: '"Times New Roman", Times, serif' }}
          >
            <span className={isDarkMode ? 'text-stone-100' : 'text-stone-900'}>idia</span>
            <span className={isDarkMode ? 'text-stone-300' : 'text-stone-500'}>wisdom.com</span>
          </div>
          
          <p className="text-[9px] font-bold uppercase tracking-[0.5em] text-stone-400 dark:text-stone-500 leading-loose opacity-70">
            {established}
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;